export const SERVICE_LOADING = 'service-loading';
export const SERVICE_LOADED = 'service-loaded';
export const SERVICE_RELOADED = 'service-reloaded';
export const SERVICE_ERROR = 'service-error';
export const LOAD_ICON = 'load-icon';
export const ASSET_PROPS_CHANGED = 'asset-props-changed';
export const ASSET_NOT_FOUND = 'asset-not-found';
export const SERVICES_ALL_LOADED = 'services-all-loaded';
export const LOOKUP_COMPLETE = 'lookup-complete';
